import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ServicioFormatoPagareService, ParametrosPagareEntity, EntidadEmpresarial, DatosPagareEntity
} from 'src/app/services/servicio-formato-pagare.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-formato-pagare',
  templateUrl: './reporte-formato-pagare.component.html',
  styleUrls: ['./reporte-formato-pagare.component.css']
})
export class ReporteFormatoPagareComponent implements OnInit {
  loading = false;
  fechaImpresion: Date;
  objetoParametrosEntity: ParametrosPagareEntity;
  datos: DatosPagareEntity[] = [];


  public parametrosPagareEntity: ParametrosPagareEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    nombreSede: '',
    uncoEntidad: '',
    uncoAdmision: ''
  };

  entidadEmpresarial: EntidadEmpresarial = {
    unco: 0,
    nombreEntidad: '',
    nit: '',
    digitoVerificacion: '',
    direccion: '',
    telefono: '',
    tipoDocumento: '',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioFormatoPagare: ServicioFormatoPagareService) {

    this.activatedRoute.params.subscribe(params => {
      this.parametrosPagareEntity.codigoBaseDatos = params['codigoBaseDatos'];
      this.parametrosPagareEntity.uncoSede = params['uncoSede'];
      this.parametrosPagareEntity.uncoEntidad = params['uncoEntidad'];
      this.parametrosPagareEntity.uncoAdmision = params['uncoAdmision'];

      // this.parametrosPagareEntity.nombreSede = params['nombreSede'];
    });

  }

  ngOnInit() {
    this.fechaImpresion = new Date();
    this.getData();

  }

  public updateEntidad(entidad: EntidadEmpresarial) {
    this.entidadEmpresarial = entidad;
  }

  async getData() {
    try {
      const response = await this.servicioFormatoPagare.getDataPagare(this.parametrosPagareEntity);
      if (response != null) {
        response.subscribe((data: DatosPagareEntity[]) => {
          this.datos = data;
          if (data == null) {
            // this.mostrarReporte = false;
            this.loading = false;
          }
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

}
